import * as React from "react";
import { Image, Text } from "react-konva";
import { Seat } from "../types";

interface Props {
  data: Seat;
  freeSeatIcon: any;
  reservedSeatIcon: any;
  selectedSeatIcon: any;
  selectSeat: (id: number, seat: Seat) => void;
  unselectSeat: (id: number) => void;
  isSelected: boolean;
  yMax: number;
  xMax: number;
  yMin: number;
  xMin: number;
  canvasWidth: number;
  canvasHeight: number;
  marginTopBottom: number;
  marginLeftRight: number;
  setHoverSeat: (seat: Seat | null) => void;
}

const SeatComponent: React.FC<Props> = ({
  data,
  selectSeat,
  isSelected,
  xMax,
  yMax,
  xMin,
  yMin,
  freeSeatIcon,
  reservedSeatIcon,
  selectedSeatIcon,
  canvasWidth,
  canvasHeight,
  marginTopBottom,
  marginLeftRight,
  unselectSeat,
  setHoverSeat,
}) => {
  // Ratio should scale to value less than height x width of Image (margins)
  const ratioY = canvasWidth / (yMax - yMin);
  const ratioX = canvasHeight / (xMax - xMin);

  const radius = 1.75 * ratioX;

  /*
  (dataX - xMin) - Translation to remove unused space in image
  
  Mulitplying to get real pixel in our 500x500 image
  Plus 250 to move whole scaled image to center of canvas
  Minus size scaled widthImage/2 to get the center
  */

  const x =
    data.X * ratioX - xMin * ratioX + (canvasWidth - (xMax - xMin) * ratioX);
  const y =
    data.Y * ratioY - yMin * ratioY + (canvasHeight - (yMax - yMin) * ratioY);

  let image = freeSeatIcon;

  const [tooltip, setTooltip] = React.useState(false);
  const tooltipRef = React.useRef(null);
  if (data.reserved) {
    image = reservedSeatIcon;
  }

  if (isSelected) {
    image = selectedSeatIcon;
  }

  const clickHandler = () => {
    if (isSelected) {
      unselectSeat(data.SeatId);
      return;
    }

    if (!data.reserved) {
      selectSeat(data.SeatId, data);
    }
  };

  const mouseOver = () => {
    setHoverSeat(data);
  };

  const mouseOut = () => {
    setHoverSeat(null);
  };

  React.useEffect(() => {
    if (tooltipRef.current !== null) {
      (tooltipRef.current as any).zIndex(999);
    }
  }, [tooltip]);

  return (
    <>
      <Image
        image={image}
        x={x - radius / 2}
        y={y}
        width={radius}
        height={radius}
        onClick={clickHandler}
        onTap={clickHandler}
        onMouseEnter={mouseOver}
        onMouseLeave={mouseOut}
        strokeWidth={0} // border width
      />
    </>
  );
};

export default SeatComponent;

/*      {tooltip ? (
        <Text
          ref={tooltipRef}
          x={x + 10}
          y={y + 20}
          fontSize={textSize}
          fill="red"
          text={"Miejsce jakieś tam 45"}
        />
      ) : null} */
